import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";

export default function Inventory() {
  const [sites, setSites] = useState([]);
  useEffect(() => { api.get("/sites").then((r) => setSites(r.data)); }, []);
  return (
    <CrudList
      title="Inventory Logistik"
      subtitle="Stok material umum & consumable per site"
      endpoint="/inventory"
      exportModule="inventory"
      columns={[
        { key: "code", label: "Kode" },
        { key: "name", label: "Nama" },
        { key: "category", label: "Kategori" },
        { key: "stock", label: "Stok" },
        { key: "unit", label: "Unit" },
        { key: "price", label: "Harga", render: (r) => "Rp " + (r.price || 0).toLocaleString('id-ID') },
        { key: "site_id", label: "Site", render: (r) => sites.find((s) => s.id === r.site_id)?.name || "-" },
      ]}
      fields={[
        { key: "code", label: "Kode", required: true },
        { key: "name", label: "Nama", required: true },
        { key: "category", label: "Kategori", placeholder: "Consumable / Material", required: true },
        { key: "stock", label: "Stok", type: "number" },
        { key: "unit", label: "Unit", placeholder: "pcs / kg / liter" },
        { key: "price", label: "Harga (Rp)", type: "number" },
        { key: "site_id", label: "Site", type: "select", options: sites.map((s) => ({ value: s.id, label: s.name })), wide: true },
      ]}
    />
  );
}
